<template>
  <div :class="classList">
    <label v-if="label" class="d-flex"
      >{{ label.trim().replace(/\*$/, "") }}
      <span v-if="isRequired" class="asterisk-mark">*</span>
    </label>
    <div
      v-if="adminDescription && $store.getters.isAgent"
      class="admin-description"
    >
      <div v-html="adminDescription"></div>
    </div>
    <div v-if="description" class="description">
      <div v-html="description"></div>
    </div>
    <DatePicker
      class="date-picker form-control registration-date"
      v-model="inputVal"
      :disabled="isDisabled"
      placeholder="yyyy"
      type="year"
    ></DatePicker>
    <p class="required-message" v-if="!inputVal && submitClicked && isRequired">
      {{ getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED") }}
    </p>
  </div>
</template>
<script>
/* This component includes a label, and a date picker
Any error of user input for the date picker (for example: required field, invalid day ...) is showed in this component */

import DatePicker from "vue2-datepicker";
export default {
  name: "YearPickerWithLabel",
  components: {
    DatePicker,
  },
  props: {
    /* Name of the date picker component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12",
    },
    // Input value, which is used for v-model
    value: [String, Date],
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false,
    },
    builderField: Object,
  },
  // created() {
  //   this.$emit("input", this.dateInDjangoFormat(new Date()));
  // },
  computed: {
    inputVal: {
      get() {
        if (this.value == null) {
          return null;
        }
        return new Date(this.value + "T00:00:00"); // This is to prevent the date from going one day behind
      },
      set(val) {
        this.$emit("input", this.dateInDjangoFormat(val));
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/form-elements/YearPickerWithLabel.vue